<template>
<div class="RollCall">
    <EventInfo :eventInfoData="eventInfoData"></EventInfo>
    <div class="rollcall_content_container spackage bgc box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
            <el-tab-pane :label="'全部 ('+activeNum.totalCount+')'" name="first">
                <RollCallTable :eventInfoData="eventInfoData" @findSimpleEventDetail="findSimpleEventDetail" :activeStatus="activeStatus" :eventListData="eventListData"></RollCallTable>
            </el-tab-pane>
            <el-tab-pane :label="'待审核 ('+activeNum.audited+')'" name="second">
                <RollCallTable :eventInfoData="eventInfoData" @findSimpleEventDetail="findSimpleEventDetail" :activeStatus="activeStatus" :eventListData="eventListData"></RollCallTable>
            </el-tab-pane>
            <el-tab-pane :label="'待支付 ('+activeNum.paying+')'" name="third">
                <RollCallTable :eventInfoData="eventInfoData" @findSimpleEventDetail="findSimpleEventDetail" :activeStatus="activeStatus" :eventListData="eventListData"></RollCallTable>
            </el-tab-pane>
            <el-tab-pane :label="'报名成功 ('+activeNum.success+')'" name="fourth">
                <RollCallTable :eventInfoData="eventInfoData" @findSimpleEventDetail="findSimpleEventDetail" :activeStatus="activeStatus" :eventListData="eventListData"></RollCallTable>
            </el-tab-pane>
            <el-tab-pane :label="'已取消 ('+activeNum.cancelled+')'" name="fifth">
                <RollCallTable :eventInfoData="eventInfoData" @findSimpleEventDetail="findSimpleEventDetail" :activeStatus="activeStatus" :eventListData="eventListData"></RollCallTable>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import EventInfo from 'views/activeOperate/components/EventInfo'
import RollCallTable from 'views/activeOperate/components/RollCallTable'
import {getEenrolleventUserList, statisticalUserNum, eventInfo} from 'api/activeApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'RollCall',
    data() {
        return {
            eventInfoData: {}, // 活动信息
            activeName: 'first',
            activeName2: 'first',
            activeStatus: 0, // 名单tab状态
            activeNum: { // 名单各个类型统计数据
                audited: 0,
                cancelled: 0,
                paying: 0,
                success: 0,
                totalCount: 0
            },
            eventListData: { // 名单列表数据
                content: [],
                pageinfo: {
                    rowCount: 0
                }
            }
        }
    },
    mounted() {
        this.findSimpleEventDetail()
        this.findStatisticalUserNum()
        this.findEenrolleventUserList(this.activeStatus)
    },
    methods: {
        // tab菜单点击切换
        handleClick(tabName) {
            if (tabName === this.activeName2) {
                // 点击同一个tab不做处理
            } else {
                this.activeName2 = tabName
                if (tabName === 'first') {
                    // 全部
                    this.activeStatus = 0
                } else if (tabName === 'second') {
                    // 待审核（40）
                    this.activeStatus = 1
                } else if (tabName === 'third') {
                    // 待支付（10）
                    this.activeStatus = 9
                } else if (tabName === 'fourth') {
                    // 报名成功（140）
                    this.activeStatus = 30
                } else if (tabName === 'fifth') {
                    // 已取消（20）
                    this.activeStatus = 100
                }
                // console.log(tabName)
                // this.findStatisticalUserNum()
                this.findEenrolleventUserList(this.activeStatus)
            }
        },
        // 查询活动基本简略信息
        findSimpleEventDetail() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            eventInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eventInfoData = data.data
                    // console.log('this.eventInfoData:', this.eventInfoData);
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 统计名单的各个状态的数量
        findStatisticalUserNum() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            statisticalUserNum({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.activeNum = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 查询名单信息列表
        findEenrolleventUserList(val) {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                eventstatus: val,
                page: 1,
                pageSize: 10
            }
            getEenrolleventUserList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.eventListData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        EventInfo,
        RollCallTable
    }
}
</script>

<style lang="scss" type="text/scss">
.RollCall {
    font-family:PingFangSC-Regular,PingFang SC;
    .rollcall_content_container {
        margin-top: 24px;
        .el-tabs__item {
            padding: 0 20px!important;
        }
        .el-tabs__header {
            margin: 0 0 24px;
        }
    }
}
</style>